import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import StoreServices from "../services/StoreServices";

const initialState = {
  loading: false,
  storeAds: [],
  storeDetail: {},
  businessStore: {},
  businessList: {},
  storeMembers: {},
  businessMembers: {},
  message: null,
  error: null,
};

export const getStore = createAsyncThunk(
  "store/getStore",
  async ({ customer_id }) => {
    if (customer_id) {
      const res = await StoreServices.getStore(customer_id);
      return res.data;
    } else {
      const res = await StoreServices.getMyStore();
      return res.data;
    }
  }
);

export const getStoreMembers = createAsyncThunk(
  "store/getStoreMembers",
  async (storeId) => {
    const res = await StoreServices.getStoreMembers(storeId);
    return res.data;
  }
);

export const addStoreMember = createAsyncThunk(
  "store/addStoreMember",
  async ({ storeId, payload }) => {
    const res = await StoreServices.addStoreMember(storeId, payload);
    return res.data;
  }
);

export const updateStoreMember = createAsyncThunk(
  "store/updateStoreMember",
  async ({ storeId, memberId, payload }) => {
    const res = await StoreServices.updateStoreMember(storeId, memberId, payload);
    return res.data;
  }
);

export const removeStoreMember = createAsyncThunk(
  "store/removeStoreMember",
  async ({ storeId, memberId }) => {
    const res = await StoreServices.removeStoreMember(storeId, memberId);
    return res.data;
  }
);

export const getStoreBySlug = createAsyncThunk(
  "store/getStoreBySlug",
  async ({ slug }) => {
    const res = await StoreServices.getStoreBySlug(slug);
    return res.data;
  }
);

export const getStoreAds = createAsyncThunk(
  "store/getStoreAds",
  async ({ customer_id, skip, limit }) => {
    const res = await StoreServices.getStoreAds(customer_id, skip, limit);
    return res.data;
  }
);

export const updateStore = createAsyncThunk(
  "store/updateStore",
  async ({ store_id, payload }) => {
    const res = await StoreServices.updateStore(store_id, payload);
    return res.data;
  }
);
export const createStore = createAsyncThunk(
  "store/createStore",
  async (payload) => {
    const res = await StoreServices.createStore(payload);
    return res.data;
  }
);
export const getBusinessStore = createAsyncThunk(
  "store/getBusinessStore",
  async ({ customer_id }) => {
    if (customer_id) {
      const res = await StoreServices.getBusinessStore(customer_id);
      return res.data;
    }
    const res = await StoreServices.getMyBusinessStore();
    return res.data;
  }
);
export const getBusinessStoreBySlug = createAsyncThunk(
  "store/getBusinessStoreBySlug",
  async ({ slug }) => {
    const res = await StoreServices.getBusinessStoreBySlug(slug);
    return res.data;
  }
);
export const updateBusinessStore = createAsyncThunk(
  "store/updateBusinessStore",
  async ({ business_id, payload }) => {
    const res = await StoreServices.updateBusinessStore(business_id, payload);
    return res.data;
  }
);
export const createBusinessStore = createAsyncThunk(
  "store/createBusinessStore",
  async (payload) => {
    const res = await StoreServices.createBusinessStore(payload);
    return res.data;
  }
);

export const getBusinessMembers = createAsyncThunk(
  "store/getBusinessMembers",
  async (businessId) => {
    const res = await StoreServices.getBusinessMembers(businessId);
    return res.data;
  }
);

export const addBusinessMember = createAsyncThunk(
  "store/addBusinessMember",
  async ({ businessId, payload }) => {
    const res = await StoreServices.addBusinessMember(businessId, payload);
    return res.data;
  }
);

export const updateBusinessMember = createAsyncThunk(
  "store/updateBusinessMember",
  async ({ businessId, memberId, payload }) => {
    const res = await StoreServices.updateBusinessMember(businessId, memberId, payload);
    return res.data;
  }
);

export const removeBusinessMember = createAsyncThunk(
  "store/removeBusinessMember",
  async ({ businessId, memberId }) => {
    const res = await StoreServices.removeBusinessMember(businessId, memberId);
    return res.data;
  }
);

export const getBusinessList = createAsyncThunk(
  "store/getBusinessList",
  async (params = {}) => {
    const res = await StoreServices.getBusinessList(params);
    return res.data;
  }
);

export const getStoreList = createAsyncThunk(
  "store/getStoreList",
  async (params = {}) => {
    const res = await StoreServices.getStoreList(params);
    return res.data;
  }
);
const handleError = (state, action) => {
  console.error(action.error?.message, action.error);
  state.error = action.error?.message;
  state.loading = false;

  if (action.type?.startsWith("store/getStore/") && !action.type.includes("Members")) {
    state.storeDetail = {};
  }

  if (action.type?.startsWith("store/getBusinessStore/")) {
    state.businessStore = {};
  }
};

const PackageSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    redirectFalse: (state) => {
      state.loading = false;
      state.redirect = false;
    },
    clearAdsErrorAndMessage: (state) => {
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: {
    [getStore.pending]: (state) => {
      state.loading = true;
    },
    [getStore.fulfilled]: (state, action) => {
      state.storeDetail = action.payload;
      state.loading = false;
    },
    [getStore.rejected]: handleError,

    [getStoreMembers.fulfilled]: (state, action) => {
      state.storeMembers = action.payload;
    },
    [getStoreMembers.rejected]: handleError,

    [addStoreMember.fulfilled]: (state, action) => {
      state.message = action.payload.message;
    },
    [addStoreMember.rejected]: handleError,

    [updateStoreMember.fulfilled]: (state, action) => {
      state.message = action.payload.message;
    },
    [updateStoreMember.rejected]: handleError,

    [removeStoreMember.fulfilled]: (state, action) => {
      state.message = action.payload.message;
    },
    [removeStoreMember.rejected]: handleError,

    [getStoreBySlug.pending]: (state) => {
      state.loading = true;
    },
    [getStoreBySlug.fulfilled]: (state, action) => {
      state.storeDetail = action.payload;
      state.loading = false;
    },
    [getStoreBySlug.rejected]: handleError,

    [getStoreAds.pending]: (state) => {
      state.loading = true;
    },
    [getStoreAds.fulfilled]: (state, action) => {
      state.storeAds = action.payload;
      state.loading = false;
    },
    [getStoreAds.rejected]: handleError,

    [updateStore.fulfilled]: (state, action) => {
      state.message = action.payload.message;
      state.loading = false;
    },
    [updateStore.rejected]: handleError,

    [createStore.pending]: (state) => {
      state.loading = true;
    },
    [createStore.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createStore.rejected]: handleError,

    [getBusinessStore.pending]: (state) => {
      state.loading = true;
    },
    [getBusinessStore.fulfilled]: (state, action) => {
      state.loading = false;
      state.businessStore = action.payload;
    },
    [getBusinessStore.rejected]: handleError,

    [getBusinessStoreBySlug.pending]: (state) => {
      state.loading = true;
    },
    [getBusinessStoreBySlug.fulfilled]: (state, action) => {
      state.loading = false;
      state.businessStore = action.payload;
    },
    [getBusinessStoreBySlug.rejected]: handleError,

    [updateBusinessStore.pending]: (state) => {
      state.loading = true;
    },
    [updateBusinessStore.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateBusinessStore.rejected]: handleError,

    [createBusinessStore.pending]: (state) => {
      state.loading = true;
    },
    [createBusinessStore.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createBusinessStore.rejected]: handleError,

    [getBusinessMembers.fulfilled]: (state, action) => {
      state.businessMembers = action.payload;
    },
    [getBusinessMembers.rejected]: handleError,

    [addBusinessMember.fulfilled]: (state, action) => {
      state.message = action.payload.message;
    },
    [addBusinessMember.rejected]: handleError,

    [updateBusinessMember.fulfilled]: (state, action) => {
      state.message = action.payload.message;
    },
    [updateBusinessMember.rejected]: handleError,

    [removeBusinessMember.fulfilled]: (state, action) => {
      state.message = action.payload.message;
    },
    [removeBusinessMember.rejected]: handleError,

    [getBusinessList.pending]: (state) => {
      state.loading = true;
    },
    [getBusinessList.fulfilled]: (state, action) => {
      state.businessList = action.payload;
      state.loading = false;
    },
    [getBusinessList.rejected]: handleError,

    [getStoreList.pending]: (state) => {
      state.loading = true;
    },
    [getStoreList.fulfilled]: (state, action) => {
      state.businessList = action.payload;
      state.loading = false;
    },
    [getStoreList.rejected]: handleError,
  },
});

export const { clearAdsErrorAndMessage, redirectFalse } = PackageSlice.actions;

const { reducer } = PackageSlice;
export default reducer;
